import * as statistics from '../actions/resident.statistics';
import * as ui from '../actions/resident.ui';

export interface State {
	loading: boolean;
}

export const initialState: State = {
	loading: false
};

export function reducer(state = initialState, action: ui.Actions | statistics.Actions): State {
	switch (action.type) {
		case statistics.SET_STATISTICS:
			return {
				...state,
				loading: false
			};
		case ui.LOADING:
			return {
				...state,
				loading: true
			};
		default:
			return state;
	}
}

export const getLoading = (state: State) => state.loading;
